import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Spinner, Badge, Button } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"

import BootstrapTable from "react-bootstrap-table-next"

import { debounce, map, range } from "lodash"
import moment from "moment"

import ToolkitProvider from "react-bootstrap-table2-toolkit"
import MyPagination from "../../components/Common/MyPagination"

//actions

import "../../assets/scss/datatables.scss"
import { AvField, AvForm } from "availity-reactstrap-validation"
import { getChallans, getExcelDownloadChallan } from "store/actions"
import ExcelDownload from "hooks/useExcelDownloadButton"
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min"
import ChallanModal from "./SingleViewModal"

const AllChallans = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const [sort, setSort] = useState("all")

  const isTablet = window.innerWidth <= 768

  const { challan, loading, allExcelChallans, total, challanCounts } =
    useSelector(state => {
      return {
        challan: state.Challan.challans,
        loading: state.Challan.loading || false,
        challanCounts: state.Challan.challans?.challanCounts,
        total: state.Challan.challans.total,
        allExcelChallans:
          state?.ExcelDownload?.excelDownloadChallan?.challans || [],
      }
    })

  const [challanModal, setChallanModal] = useState({ status: false, data: "" })

  const [totalItemLimit, setTotalItemLimit] = useState(() => {
    return parseInt(localStorage.getItem("challanLimit")) || 10
  })
  const [pageChallan, setPageChallan] = useState(1)
  const [challanSearchText, setChallanSearchText] = useState("")

  const [finalDateFormatted, setFinalDateFormatted] = useState({
    from: "",
    to: "",
  })

  const updatedLocation = {
    ...location,
    state: {
      ...location.state,
      page: 1,
    },
  }

  const handleDateSearch = () => {
    if (
      finalDateFormatted?.from?.length >= 1 &&
      finalDateFormatted?.to?.length >= 1
    ) {
      return finalDateFormatted
    } else {
      return {
        from: "",
        to: "",
      }
    }
  }

  //pagination
  const totalPages = Math.ceil(total / totalItemLimit)
  const challanPages = range(1, totalPages + 1)

  useEffect(() => {
    dispatch(
      getChallans(
        pageChallan,
        totalItemLimit,
        challanSearchText,
        sort,
        handleDateSearch()
      )
    )
  }, [pageChallan, totalItemLimit, challanSearchText, sort, finalDateFormatted])

  const columns = [
    {
      dataField: "challan_id",
      text: "Challan ID",
      sort: true,
      filterText: "",
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "phone",
      text: "Phone",
      sort: true,
    },
    {
      dataField: "amount",
      text: "Amount",
      sort: true,
    },
    {
      dataField: "description",
      text: "Description",
      sort: true,
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
    },
    {
      dataField: "action",
      classes: "text-center action-cell",
      headerClasses: "text-center action-cell",

      text: "Actions",
    },
  ]

  const challanData = map(challan?.challans, (item, index) => ({
    ...item,
    key: index,
    rowNo: <span>{index + 1 + (pageChallan - 1) * totalItemLimit}</span>,
    challan_id: item?.challan_id,
    name: (
      <div
        style={{
          maxWidth: "200px",
          minWidth: "100px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        title={item?.name} // optional: shows full name on hover
      >
        {item?.name?.charAt(0)?.toUpperCase() + item?.name?.slice(1)}
      </div>
    ),
    phone: (
      // <span>{item?.phone || "---"}</span>
      <span>
        {item?.country_code
          ? `${item.country_code}-${item.phone}`
          : item?.phone}
      </span>
    ),
    amount: item?.amount ? item?.amount : "---",

    description: (
      <div
        style={{
          maxWidth: "280px",
          minWidth: "100px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        title={item?.description} // optional: shows full name on hover
      >
        {item?.description?.charAt(0)?.toUpperCase() +
          item?.description?.slice(1)}
      </div>
    ),
    status: (
      <Badge
        className={`font-size-12 badge-soft-${
          item?.status === "PENDING"
            ? "info"
            : item?.status === "FAILED"
            ? "danger"
            : "success"
        } me-2 mt-1`}
        color=""
        pill
      >
        {item?.status
          ? item.status.charAt(0).toUpperCase() +
            item.status.slice(1).toLowerCase()
          : "--"}
      </Badge>
    ),
    paymentVerified: (
      <Badge
        className={`font-size-12 badge-soft-${
          item?.is_verified ? "success" : "danger"
        } me-2 mt-1`}
        color=""
        pill
      >
        {item?.is_verified ? "Verified" : "Not Verified"}
      </Badge>
    ),
    action: (
      <>
        <div
          className="d-flex gap-1"
          style={{ width: "100%", justifyContent: "center" }}
        >
          <Button
            onClick={() => setChallanModal({ status: true, data: item })}
            id={`view${index}`}
            type="button"
            title="View Challan Receipt"
            color="white"
            className=" btn"
          >
            <i className="bx bx-show-alt " style={{ fontSize: "20px" }} />
          </Button>
        </div>
      </>
    ),
  }))

  const handleTableChange = (type, { page, searchText }) => {
    setUserList()
  }

  const debounceChallanSearch = debounce(
    value => setChallanSearchText(value),
    600
  )

  const handlePageLimit = e => {
    if (e.target.value >= 1) {
      setTotalItemLimit(parseInt(e.target.value))
      localStorage.setItem("challanLimit", e.target.value)
    }
  }

  const handleChallanSearch = value => {
    debounceChallanSearch(value)
    history.push(updatedLocation)
  }

  const [isExcelLoading, setIsExcelLoading] = useState(false)
  const sortValue = sort === "all" ? "" : sort

  const handleExcelDownload = async () => {
    setIsExcelLoading(true)
    try {
      await dispatch(
        getExcelDownloadChallan(
          pageChallan,
          totalItemLimit,
          challanSearchText,
          sortValue,
          handleDateSearch()
        )
      )
    } finally {
      setIsExcelLoading(false)
    }
  }

  const headers = [
    { label: "No", key: "no" },
    { label: "Date", key: "createdAt" },
    { label: "Challan Id", key: "challan_id" },
    { label: "Name", key: "challan_name" },
    { label: "Phone", key: "phone" },
    { label: "Status", key: "status" },
    { label: "Description", key: "description" },
    { label: "Amount", key: "amount" },
    { label: "Verified", key: "is_verified" },
  ]

  const formattedCreateDates = item => {
    return moment(item?.createdAt).format("DD/MM/YYYY h:m:a")
  }

  const excelDownloadChallans = map(allExcelChallans, (item, key) => ({
    ...item,
    no: key + 1,
    createdAt: formattedCreateDates(item),
    challan_id: item?.challan_id,
    challan_name: item?.name,
    phone: item.phone,
    description: item?.description,
    amount: item?.amount,
    is_verified: item?.is_verified,
    status: item.status,
  }))
  const statusValues = [
    { label: "All", value: "all", count: challanCounts?.ALL || 0 },
    {
      label: "Pending",
      value: "PENDING",
      count: challanCounts?.PENDING || 0,
    },
    {
      label: "Success",
      value: "SUCCESS",
      count: challanCounts?.SUCCESS || 0,
    },
    {
      label: "Failed",
      value: "FAILED",
      count: challanCounts?.FAILED || 0,
    },
  ]
  const listChange = sortValue => {
    setSort(sortValue)
    history?.push({
      pathname: location?.pathname,
      search: `p=${pageChallan}&s=${sortValue}`,
      state: {
        page: pageChallan,
        sort: sortValue,
      },
    })
  }

  useEffect(() => {
    if (location?.state && location?.state?.sort) {
      setSort(location?.state?.sort)
    } else {
      setSort("all")
    }
  }, [location?.state?.sort])

  const onCloseClickChallan = () => {
    setChallanModal({ status: false, data: "" })
  }
  return (
    <React.Fragment>
      {challanModal && (
        <ChallanModal
          show={challanModal?.status}
          onCloseClick={() =>
            onCloseClickChallan({ ...challanModal, status: false, data: "" })
          }
          updateData={challanModal?.data}
        />
      )}
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody className="position-relative">
              <Row>
                <Col className=" col-12 col-lg-5 mt-1">
                  {map(statusValues, (head, key) => (
                    <>
                      <input
                        type="radio"
                        className="btn-check"
                        name="btnradio"
                        id={key + 1}
                        autoComplete="off"
                        checked={sort === head.value}
                        onChange={() => listChange(head?.value)}
                      />
                      <label
                        className="btn btn-warning"
                        htmlFor={key + 1}
                        style={{
                          borderRadius: 1,
                        }}
                      >
                        {head?.label}
                        <Badge
                          className={`font-size-12 ms-2 ${
                            sort === head.value
                              ? "badge-soft-light"
                              : "badge-soft-light"
                          }`}
                          pill
                        >
                          {head?.count}
                        </Badge>
                      </label>
                    </>
                  ))}
                </Col>
                <Col className=" col-7">
                  <>
                    <div className={`headerOptionWrap p-1`}>
                      <div className="headerOptionSubWrap  align-items-center flex-wrap ">
                        <div className={`d-flex ${isTablet ? "mt-2" : "mt-0"}`}>
                          {" "}
                          <div className={"py-2"}>
                            <div className="search-box  w-100 mb-3 d-inline-block ">
                              <div className="position-relative">
                                <AvForm>
                                  <AvField
                                    name="searchText"
                                    placeholder="Search"
                                    type="text"
                                    onChange={e =>
                                      handleChallanSearch(e.target.value)
                                    }
                                    style={{
                                      width: isTablet ? "210px" : "150px",
                                    }}
                                  />
                                </AvForm>
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>{" "}
                          </div>
                          <div className={"py-1"}>
                            <AvForm className="form-horizontal limit-Wrapper mx-2 mb-3 d-flex align-items-center">
                              <div className="mx-1">
                                <span className="">
                                  Show
                                  <i className="fas fa-sort-numeric-down-alt mx-1"></i>
                                </span>
                              </div>
                              <div className="" style={{ width: "50px" }}>
                                <AvField
                                  name="pageLimit"
                                  className="form-control"
                                  value={totalItemLimit}
                                  onChange={e => handlePageLimit(e)}
                                  type="text"
                                  required
                                />
                              </div>
                            </AvForm>{" "}
                          </div>
                          <AvForm
                            style={{
                              marginTop: isTablet ? "-14px" : "-14px",

                              flexDirection: "column",
                              marginLeft: ".5rem",
                              display: "flex",
                              // alignItems: "center",
                              maxheight: "42px",
                            }}
                          >
                            <span className="">Sort By Date</span>

                            <div className={`d-flex date_wrapper `}>
                              <div className="d-flex align-items-start position-relative">
                                <AvField
                                  name="dateRange"
                                  type="date"
                                  validate={{
                                    dateRange: {
                                      start: { value: -5, units: "years" },
                                      end: { value: 5, units: "years" },
                                    },
                                  }}
                                  onChange={e => {
                                    setFinalDateFormatted({
                                      ...finalDateFormatted,
                                      from: e.target.value,
                                    })
                                    history.push(updatedLocation)
                                  }}
                                  value={finalDateFormatted?.from}
                                />
                                <button
                                  onClick={() => {
                                    setFinalDateFormatted({
                                      ...finalDateFormatted,
                                      from: "",
                                    })
                                    history.push(updatedLocation)
                                  }}
                                  type="button"
                                  className="btn btn-white editable-cancel date_close btn-sm"
                                >
                                  <i className="mdi mdi-close text-danger "></i>
                                </button>
                              </div>
                              <div className="d-flex align-items-start position-relative">
                                <AvField
                                  name="dateRange"
                                  className="mx-1"
                                  type="date"
                                  validate={{
                                    dateRange: {
                                      start: { value: -5, units: "years" },
                                      end: { value: 5, units: "years" },
                                    },
                                  }}
                                  onChange={e =>
                                    setFinalDateFormatted({
                                      ...finalDateFormatted,
                                      to: e.target.value,
                                    })
                                  }
                                  value={finalDateFormatted?.to}
                                />
                                <button
                                  onClick={() =>
                                    setFinalDateFormatted({
                                      ...finalDateFormatted,
                                      to: "",
                                    })
                                  }
                                  type="button"
                                  className="btn btn-white editable-cancel date_close btn-sm"
                                >
                                  <i className="mdi mdi-close text-danger "></i>
                                </button>
                              </div>
                            </div>
                          </AvForm>
                        </div>
                      </div>
                    </div>
                  </>
                </Col>
              </Row>

              <div className="">
                <ToolkitProvider
                  keyField="_id"
                  columns={columns}
                  data={challanData}
                  search
                >
                  {toolkitProps => (
                    <React.Fragment>
                      {loading ? (
                        <Spinner color="secondary" className="d-block m-auto" />
                      ) : (
                        <>
                          {challan?.challans?.length ? (
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    key={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    onTableChange={handleTableChange}
                                  />
                                </div>
                              </Col>
                            </Row>
                          ) : (
                            <p
                              className="my-4 mx-3"
                              style={{ textTransform: "capitalize" }}
                            >
                              No challans available.{" "}
                            </p>
                          )}
                          <div className="d-flex align-items-center justify-content-between px-4">
                            <div className="w-75">
                              <MyPagination
                                totalPages={challanPages}
                                page={pageChallan}
                                setPage={setPageChallan}
                              />
                            </div>
                            <div>
                              {allExcelChallans?.length >= 1 ? (
                                <ExcelDownload
                                  title="Challan Reports"
                                  headers={headers}
                                  excelDownloadData={excelDownloadChallans}
                                  isLoading={isExcelLoading}
                                  onDownloadClick={handleExcelDownload}
                                />
                              ) : (
                                ""
                              )}
                            </div>
                            {/* ) : (
                              ""
                            )} */}
                          </div>
                        </>
                      )}
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default AllChallans

const STATUS = [
  { label: "All", value: "" },
  { label: "PENDING", value: "pending" },
  { label: "SUCCESS", value: "SUCCESS" },
]
